import apiService from './api'
import { User } from '../types'

export interface UpdateProfileData {
  firstName?: string
  lastName?: string
  email?: string
  password?: string
}

class UserService {
  async getCurrentUser(): Promise<User> {
    return apiService.get<{ user: User }>('/auth/me').then(data => data.user)
  }

  async updateProfile(data: UpdateProfileData): Promise<User> {
    const payload: any = {}
    
    if (data.firstName) payload.first_name = data.firstName
    if (data.lastName) payload.last_name = data.lastName
    if (data.email) payload.email = data.email
    if (data.password) payload.password = data.password
    
    return apiService.put<{ user: User }>('/auth/profile', payload).then(data => data.user)
  }

  async refreshToken(): Promise<string> {
    return apiService.post<{ token: string }>('/auth/refresh').then(data => data.token)
  }
}

export const userService = new UserService()
export default userService